const globalConfig = {
    NAMESHOP: 'JADO',
    SITE_URL: 'jado.in.ua',
};

export default globalConfig;